module.exports = __webpack_public_path__ + "img/119.4eca12e8.jpg";